<!-- Alert -->
@if (alerts().length > 0) {
  @for (alert of alerts(); track alert.timestamp) {
    <app-alert
      [type]="alert.type"
      [id]="alert.id"
      [closeable]="alert.closeable"
      [animation]="true"
    >
      <div>
        @for (message of alert.message ; track index; let index = $index) {
          <div>{{ message | translate }}</div>
        }
      </div>
    </app-alert>
  }
}
